import React from 'react';
import { Briefcase, Layers, Cpu, GraduationCap, Network, ArrowRight } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const services = [{
  title: "Project Management",
  description: "Expert end-to-end delivery of complex projects with a focus on quality, timeline, and budget. No retainers, just results.",
  link: "/ServicesPage",
  icon: Briefcase
}, {
  title: "Device Refresh and Upgrades",
  description: "End-to-end device refresh project delivery, including cabling, AP installations, rack and stack of devices, labeling, complete project management, change control, and documents for handover to Operations – HOTS — cutover management, UAT, test results.",
  link: "/ServicesPage",
  icon: Cpu
}, {
  title: "Programme Management",
  description: "Strategic oversight of multiple related projects to achieve high-level business objectives and organizational change.",
  link: "/ServicesPage",
  icon: Layers
}, {
  title: "ServiceNow Implementation",
  description: "Seamless platform migration and custom implementation tailored to your enterprise workflow and service management needs.",
  link: "/ServicesPage",
  icon: Cpu
}, {
  title: "Professional Training",
  description: "Accredited PMP, PRINCE2, and ACP certification courses led by senior practitioners to advance your team's capability.",
  link: "/TrainingPage",
  icon: GraduationCap
}, {
  title: "Field Services",
  description: "Technical excellence in cabling, network surveys, and infrastructure deployment with guaranteed uptime and reliability.",
  link: "/FieldServicesPage",
  icon: Network
}];
export default function OurServices() {
  return <section id="services" className="py-16 bg-[#0d1b2a] relative overflow-hidden bg-gradient-to-b from-[#060f1a] via-[#0d1b2a] to-[#060f1a]">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full pointer-events-none opacity-10">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-[#00c4b4]/20 rounded-lg blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-[#00c4b4]/20 rounded-lg blur-[120px]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-white font-bold tracking-wider uppercase text-xs mb-3">Our Expertise</h2>
          <p className="text-3xl md:text-5xl font-extrabold text-white tracking-tight mb-4">
            World-Class Solutions. Delivered.
          </p>
          <div className="h-1 w-12 bg-[#00c4b4] mx-auto rounded-lg mb-6" />
          <p className="text-lg text-white/70 max-w-2xl mx-auto leading-relaxed">
            Projectora provides senior-level consultancy specializing in outcome-based delivery models that eliminate unnecessary overheads and focus on your success.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => <div key={service.title} data-index={i} className="group flex flex-col h-full bg-[#112234] border border-white/5 border-t-2 border-t-[#00c4b4] rounded-xl p-7 transition-all duration-300 hover:shadow-xl hover:shadow-[#00c4b4]/5">
              <div className="mb-6 w-12 h-12 rounded-lg bg-[#0d1b2a] flex items-center justify-center text-[#00c4b4] group-hover:bg-[#00c4b4] group-hover:text-white transition-all duration-500">
                <service.icon size={24} strokeWidth={1.5} />
              </div>
              
              <h3 className="text-xl font-bold text-white mb-3 tracking-tight">
                {service.title}
              </h3>
              
              <p className="text-white/70 text-sm leading-relaxed mb-8 flex-grow">
                {service.description}
              </p>
              
              <div className="mt-auto">
                <Link to={service.link} className="inline-flex items-center text-sm font-semibold text-[#00c4b4] group/link">
                  Explore Service 
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover/link:translate-x-1" />
                </Link>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center">
          <Button asChild className="bg-[#00c4b4] hover:bg-[#00a89a] text-white px-10 py-6 rounded-lg font-bold text-sm tracking-wide uppercase transition-all duration-300 shadow-lg hover:shadow-[#00c4b4]/20 hover:-translate-y-0.5 mt-8 mb-8 cursor-pointer">
            <Link to="/ContactPage">
              Partner with us
            </Link>
          </Button>
          <p className="text-[#00c4b4] font-mono uppercase tracking-[0.3em] font-bold !text-xl">MILESTONE-BASED DELIVERY. NO RETAINERS. NO SURPRISES.</p>
        </div>
      </div>
    </section>;
}